import { RefObject, useEffect } from 'react'

type FocusWithinDetectionProps = {
  containerRef: RefObject<HTMLElement>
  onFocusIn?: () => void
  onFocusOut?: () => void
}

const useFocusWithinDetection = ({
  containerRef,
  onFocusIn,
  onFocusOut
}: FocusWithinDetectionProps) => {
  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const handleFocusOut = (event: FocusEvent) => {
      if (!container.contains(event.relatedTarget as Node)) {
        onFocusOut?.()
      }
    }
    if (onFocusIn) {
      container.addEventListener('focusin', onFocusIn)
    }
    if (onFocusOut) {
      container.addEventListener('focusout', handleFocusOut)
    }
    return () => {
      if (onFocusIn) {
        container.removeEventListener('focusin', onFocusIn)
      }
      if (onFocusOut) {
        container.removeEventListener('focusout', handleFocusOut)
      }
    }
  }, [containerRef, onFocusIn, onFocusOut])
}

export default useFocusWithinDetection
